import {
  AUTH_PATHS,
  LOGIN_PATH,
  parseConsentPath,
  parsePayPath,
  parseSurveyPath,
  PUBLIC_PATHS,
} from '../routes.js';
import type { MaintenanceAudience } from './maintenance-screen.js';

const PUBLIC_EXACT = new Set<string>([...PUBLIC_PATHS, LOGIN_PATH, ...Object.values(AUTH_PATHS)]);

/**
 * Bakım ekranına kim bakıyor? Oturumu olan personel her zaman `clinic`. Oturum bilinmiyorsa
 * (ön kapının bağımsız bakım sayfası) adres karar verir: hastanın açtığı sayfalar ve giriş/şifre
 * ekranları `public` — orada klinik içi yönetici notu gösterilmez.
 */
export function maintenanceAudience(pathname: string, hasSession = false): MaintenanceAudience {
  if (hasSession) return 'clinic';
  const clean = pathname.replace(/\/+$/, '') || '/';
  if (PUBLIC_EXACT.has(clean)) return 'public';
  // Hastanın belirteçli bağlantıları. Onam ve anket 2026-09-25'e kadar burada YOKTU: bakım
  // sırasında onlara bağlantıyı açan hasta, klinik içi yönetici notunu görürdü.
  if (parsePayPath(clean) ?? parseConsentPath(clean) ?? parseSurveyPath(clean)) return 'public';
  return 'clinic';
}
